<template>
  <div id="content-table">
    <div class="d-flex justify-end">
      <div class="mx-8 my-4">
        <div class="d-flex justify-end">
          <span class="black--text font-weight-bold" style='font-family:"MS Pゴシック", sans-serif !important; font-size: 11px'>Confidential</span>
        </div>
        <v-img :src="require('@/assets/images/report_header.png')" width="120px" eager></v-img>
      </div>
    </div>
    <div class="ma-10 mt-0" style="height: 930px;">
      <div class="d-flex justify-start mb-3">
        <span class="text-h5 font-weight-bold font-weight-black">目次</span>
      </div>
      <ol class="text-subtitle-1 black--text px-0">
        <li>
          概要
          <ul class="no-bulleted">
            <li>発電所情報</li>
            <li>撮影条件</li>
          </ul>
        </li>
        <li v-if="naviList.find(item => item.text === 'サーマルオルソ画像').visible">サーマルオルソ画像 <sup><small>注）</small></sup></li>
        <li v-if="naviList.find(item => item.text === 'RGBオルソ画像').visible">RGBオルソ画像 <sup><small>注）</small></sup></li>
        <li>故障モード解説</li>
        <li>ドローン検査結果</li>
        <li>ドローン検査詳細（抜粋）</li>
        <li v-for="(i, index) in naviList.slice(naviList.findIndex(item => item.text === 'ドローン検査詳細（抜粋）') + 1)" :key="index">{{getTitle(i.text)}}</li>
        <p class="text-caption mt-16 text-justify">
          注）オルソ画像とは、複数の撮影写真を用いることで、画像のずれを補正し正面（上空真上）から俯瞰した状態に変換した画像のことです。なお、天候や現場の状況によりオルソ画像が正常に作成されないことがあり、その場合は本報告書にオルソ画像は掲載しておりません。但し、検査はオルソ画像の素材となる1枚1枚の写真を基に実施しておりますので、検査内容および異常判定結果に影響があるものではございません。
        </p>
      </ol>
    </div>
    <div class="mr-8">
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐‐</span>
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 12px">2/{{ naviVisibleList.length + pdfPageNum + cropImagePageNum + 1}}</span>
      </div>
      <div class="d-flex align-end justify-end">
        <span class="font-weight-bold black--text" style="font-family: 'MS Pゴシック', sans-serif !important; font-size: 11px">Copyright East Engineering Co., Ltd. all rights reserved</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContentTable",
  props: ['naviList', 'naviVisibleList', 'cropImagePageNum', 'pdfPageNum'],
  methods: {
    getTitle(text){
      if (text){
        if (text.includes('blank')) return '';
        else return text;
      }
      return '';
    }
  }
}
</script>

<style scoped>
.no-bulleted {
  list-style-type: none;
}

li {
  margin: 20px;
}
</style>
